import { Carousel } from "react-bootstrap"
import React from "react"
import { Link } from "react-router-dom"

export default function ScrollBanner() {
  return (
    <Carousel>
      <Carousel.Item>
        <Link to="/category/vegetables">
          <img
            className="d-block banners"
            src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/Pantry/Sept2020/Coop/Henko750x375px.jpg"
            alt="First slide"
          />
        </Link>
      </Carousel.Item>
      <Carousel.Item>
        <Link to="/category/kirana">
          <img
            className="d-block banners"
            src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/Pantry/Oct2020/Coop/Festive_store_750x375.jpg"
            alt="Second slide"
          />
        </Link>
      </Carousel.Item>
      <Carousel.Item>
        <Link to="/category/dairy">
          <img
            className="d-block banners"
            src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/AmazonPantry/February/NiveaSVDBanners/750x375.jpg"
            alt="Third slide"
          />
        </Link>
      </Carousel.Item>
    </Carousel>
  )
}
